import { createApp } from "vue";
import i18n from '../translations/i18n';
import PasswordReset from "../../components/PasswordReset";
import NewPassword from "../../components/NewPassword";

export const initializePasswordResetApp = () => {
    if (!document.getElementById('js_passwordResetApp')) {
        return;
    }

    const app = createApp({});

    app.use(i18n);

    app.component('password-reset', PasswordReset);
    app.component('new-password', NewPassword);

    app.mount('#js_passwordResetApp');
};
